export default __webpack_public_path__ + "static/media/charts-series-detail.f0083c74.svg";